// extracted by mini-css-extract-plugin
export default {"dayProgress":"progressOutline_dayProgress__cgavt"};